import { Stack } from '@mui/material';
import { useProductsTFunction } from '@retail/products/i18n';
import { MgSupplierItemClimate } from '@retail/products/types';
import { ProductInformationCard } from '../ProductInformation/ProductInformationCard';
import { GwpPhases } from './GWPContent';
import { GWPNumberElement } from './GWPNumberElement';

interface Props {
  data?: MgSupplierItemClimate['data'];
}

export const GWPGhgContent = ({ data }: Props) => {
  const t = useProductsTFunction();
  const calculation = data?.calculatedFromEpd?.epdCalculationA;

  const a1ToA3 = calculation?.calculatedGwpGhgA1A3KG;
  const a4 = calculation?.calculatedGwpGhgA4KG;
  const a5 = calculation?.calculatedGwpGhgA5KG;

  if (a1ToA3 == null && a4 == null && a5 == null) return null;

  return (
    <ProductInformationCard
      title={`${t('products.mgItem.gwpGhg.title')} – ${t('products.mgItem.gwp.unitPerKg')}`}
    >
      <Stack display="grid" gridTemplateColumns="1fr 1fr 1fr">
        <GWPNumberElement
          title={t('products.mgItem.gwp.A1ToA3')}
          phase={GwpPhases.A1ToA3}
          value={a1ToA3}
        />
        <GWPNumberElement title={t('products.mgItem.gwp.A4')} phase={GwpPhases.A4} value={a4} />
        <GWPNumberElement title={t('products.mgItem.gwp.A5')} phase={GwpPhases.A5} value={a5} />
      </Stack>
    </ProductInformationCard>
  );
};
